import { AbstractControl, FormControl } from '@angular/forms';
import { CartLine } from '@next/core-lib/cart';
import { TableColumn, TableColumnTypes } from '@next/core-lib/table';
import { CartColumns } from 'src/app/cart/models/app.models';

import { decorateFormControl } from 'src/app/product/helpers/add-to-cart-helpers';

import { createQuantityUnitSuffixArray } from './create-quantity-unit-suffix';
import { CartComponent } from '../../cart.component';

export const createOrderColumns = (componentRef: CartComponent): TableColumn[] => [
  {
    id: CartColumns.skuTitle,
    type: TableColumnTypes.TEMPLATE,
    label: `cart.cart-column-${CartColumns.skuTitle}`,
    template: componentRef.columnSkuTitleRef.instance.template,
    className: 'flex__child--2',
    headerClassName: 'flex__child--2',
    disableSort: true,
  },
  {
    id: CartColumns.quantity,
    type: componentRef.editable ? TableColumnTypes.INPUT_NUMBER : TableColumnTypes.NUMBER,
    label: `cart.cart-column-${CartColumns.quantityAndUnitInformation}`,
    inputConfig: componentRef.editable && {
      callback: (row: CartLine, control: AbstractControl) => componentRef.debounceQuantityChange$.next({ row, control }),
      formArray: componentRef.orderQuantities,
      step: componentRef.getQuantityStep,
      decorateFormControl: (row: CartLine, control: FormControl) => decorateFormControl(row, control, componentRef.locale),
      suffixArray: createQuantityUnitSuffixArray(componentRef),
    },
    numberConfig: !componentRef.editable && {
      suffixArray: createQuantityUnitSuffixArray(componentRef),
    },
    className: 'flex__child--2 spacing--padding-half-vertical',
    headerClassName: 'flex__child--2',
    disableSort: true,
  },
];
